var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 96,
  viewBox: "0 0 120 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#email_svg__filter0_ddi_4438_2095)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.4898 53.7C84.3498 54.72 83.5398 55.48 82.5698 55.6C82.3798 55.62 82.1898 55.62 81.9898 55.6L65.7698 53.34L67.3598 70.12C67.4698 71.32 66.6098 72.39 65.4198 72.53C65.3998 72.53 65.3798 72.53 65.3598 72.53C64.1398 72.65 63.0598 71.75 62.9398 70.53L61.2498 52.7H61.1498C58.1098 52.26 55.7198 50.02 55.0598 47.09L37.3598 44.67C36.1498 44.5 35.2998 43.38 35.4598 42.17C35.6298 40.95 36.7398 40.1 37.9598 40.27L54.5598 42.54L52.9698 25.82C52.8498 24.6 53.7498 23.5 54.9698 23.4C56.1898 23.28 57.2698 24.18 57.3898 25.4L59.3198 45.74C59.4398 47.05 60.4498 48.1 61.7698 48.29L82.5998 51.2C83.8098 51.37 84.6598 52.49 84.4898 53.71V53.7ZM87.9198 58.67L70.1298 76.03C69.0098 77.13 67.5898 77.76 66.1098 77.94C63.8498 78.22 61.4398 77.44 59.6798 75.64L32.2498 47.74C29.3198 44.76 29.2498 40.09 32.0798 37.32L49.8698 19.97C50.9898 18.87 52.4098 18.24 53.8898 18.06C56.1498 17.78 58.5598 18.56 60.3198 20.36L87.7498 48.27C90.6798 51.25 90.7498 55.92 87.9198 58.69V58.67ZM85.5598 53.69C85.5598 52.84 85.2198 52.02 84.5898 51.37L57.1598 23.47C56.4198 22.72 55.3998 22.35 54.4298 22.47C54.0298 22.52 53.4598 22.68 52.9698 23.16L35.1698 40.51C34.5698 41.1 34.4398 41.81 34.4298 42.31C34.4298 43.16 34.7698 43.98 35.3998 44.63L62.8298 72.54C63.5698 73.29 64.5898 73.66 65.5598 73.54C65.9598 73.49 66.5298 73.33 67.0198 72.85L84.8098 55.49C85.4098 54.9 85.5398 54.19 85.5498 53.69H85.5598Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "email_svg__filter0_ddi_4438_2095",
  x: 0.00390625,
  y: -11.9956,
  width: 119.992,
  height: 119.991,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.346112 0 0 0 0 0.344375 0 0 0 0 0.483333 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2095"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2095",
  result: "effect2_dropShadow_4438_2095"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2095",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2095"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "email_svg__gray",
  x1: 30.0049,
  y1: 18.0044,
  x2: 85.4461,
  y2: 84.2992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "email_svg__yellow",
  x1: 30.0049,
  y1: 18.0044,
  x2: 85.4461,
  y2: 84.2992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "assets/icons/email.96e147.svg";